// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import ReturnForm from './forms/return-form';


// Component
export default class AddReturn extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    // Save the initial form values in the state on mount, because we don't want
    // to reinitialize the form if something about the EB changes while we're editing
    // it (like when it gets set to syncing while saving to the api)
    this.setState({ initialFormValues: getInitialFormValues(this.props.expenseBill) });
  }

  render() {
    const { expenseBill, updatePurchaseOrder, cancel } = this.props;

    return (
      <tr>
        <td colSpan="6" className="form-container return-form-container">
          <ReturnForm
            cancel={this.props.cancel}
            form={`addReturnForm-${expenseBill.id}`}
            initialValues={this.state.initialFormValues}
            header="Add Return"
            onSubmit={(values) =>
              ExpenseBill.create(formatReturn(values))
                .then(() => PurchaseOrder.findOne(values.purchaseOrderId, PurchaseOrder.defaultQuery))
                .then(updatePurchaseOrder)
                .then(cancel)
                .catch(alerts.catchError)
            }
          />
        </td>
      </tr>
    );
  }
}

// Prop types
AddReturn.propTypes = {
  cancel: PropTypes.func.isRequired,
  expenseBill: PropTypes.object.isRequired,
  updatePurchaseOrder: PropTypes.func.isRequired
};


// Helper functions
function formatReturn(data) {
  // Reverse the sign of line item unit cost, shipping, and tax, because these are all shown as positive "Refunds" in
  // the form, but are saved as negative amounts in the database
  const lineItems = _.cloneDeep(_.filter(data.lineItems, (lineItem) => Number(lineItem.quantity) > 0));
  _.forEach(lineItems, (lineItem) => { lineItem.unitCost = lineItem.unitCost * -1; });
  const lineItemTotal = _.sum(_.map(lineItems, (lineItem) => lineItem.quantity * lineItem.unitCost));
  // Only reverse the sign of shipping if it is a shipping refund (in which case it is shown in the form
  // as a positive number, but needs to be saved as a negative number)
  const shipping = Number(data.shippingType === 'fee' ? data.shipping : data.shipping * -1 || 0);
  const tax = Number(data.tax * -1 || 0);

  return {
    purchaseOrder: data.purchaseOrderId,
    date: data.date || moment().toDate(),
    shipping,
    tax,
    amount: lineItemTotal + shipping + tax,
    lineItems,
    approved: true,
    receipt: data.receipt,
    returnFor: data.id
  };
}

function getInitialFormValues(expenseBill) {
  return {
    ...expenseBill,
    date: null,
    shipping: expenseBill.shipping || 0,
    purchaseOrderId: expenseBill.purchaseOrder,
    lineItems: _.map(expenseBill.lineItems, (lineItem) => ({
      ..._.omit(lineItem, 'id'),
      description: lineItem.purchaseOrderLineItem.description,
      billableQuantity: lineItem.purchaseOrderLineItem.unbilledQuantity + lineItem.quantity
    }))
  };
}
